let FilterContextual = class {
  clear (target) {
    let parent = $(target).parent();
    parent.find('input:checkbox').removeAttr('checked');
    parent.submit();
  }
};

window.sflow = window.sflow || {};
window.sflow.filterContextual = new FilterContextual();
